module.exports = __webpack_public_path__ + "assets/img/logo-info-calorie-black.3ea354c1.png";